/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { MoovError } from "./mooverror.js";

export type AddCapabilitiesErrorData = {
  error?: string | undefined;
  capabilities?: { [k: string]: string } | undefined;
};

export class AddCapabilitiesError extends MoovError {
  error?: string | undefined;
  capabilities?: { [k: string]: string } | undefined;

  /** The original data that was passed to this error instance. */
  data$: AddCapabilitiesErrorData;

  constructor(
    err: AddCapabilitiesErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    if (err.error != null) this.error = err.error;
    if (err.capabilities != null) this.capabilities = err.capabilities;

    this.name = "AddCapabilitiesError";
  }
}

/** @internal */
export const AddCapabilitiesError$inboundSchema: z.ZodType<
  AddCapabilitiesError,
  z.ZodTypeDef,
  unknown
> = z.object({
  error: z.string().optional(),
  capabilities: z.record(z.string()).optional(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new AddCapabilitiesError(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type AddCapabilitiesError$Outbound = {
  error?: string | undefined;
  capabilities?: { [k: string]: string } | undefined;
};

/** @internal */
export const AddCapabilitiesError$outboundSchema: z.ZodType<
  AddCapabilitiesError$Outbound,
  z.ZodTypeDef,
  AddCapabilitiesError
> = z.instanceof(AddCapabilitiesError)
  .transform(v => v.data$)
  .pipe(z.object({
    error: z.string().optional(),
    capabilities: z.record(z.string()).optional(),
  }));
